import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.email"],
  email => email
);
